/**
 * Draggable Event Component
 * Used in calendar views for drag-and-drop scheduling
 */
import { useDraggable } from "@dnd-kit/core";
import { GripVertical, Clock, MapPin } from "lucide-react";
import { getEventTypeStyle } from "./constants";

export const DraggableEvent = ({ event, onClick, compact = false }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: event.event_id,
    data: { event }
  });

  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    zIndex: 1000,
  } : undefined;

  if (compact) {
    return (
      <div
        ref={setNodeRef}
        style={style}
        className={`text-xs px-1.5 py-0.5 rounded truncate cursor-grab active:cursor-grabbing flex items-center gap-1 border ${getEventTypeStyle(event.type)} ${isDragging ? 'opacity-50 shadow-lg' : ''}`}
        onClick={(e) => { e.stopPropagation(); onClick(event); }}
        {...listeners}
        {...attributes}
      >
        <GripVertical className="w-3 h-3 opacity-50 flex-shrink-0" />
        <span className="truncate">{event.title}</span>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`p-2 rounded-lg border cursor-grab active:cursor-grabbing ${getEventTypeStyle(event.type)} ${isDragging ? 'opacity-50 shadow-lg' : ''}`}
      onClick={(e) => { e.stopPropagation(); onClick(event); }}
      {...listeners}
      {...attributes}
    >
      <div className="flex items-start gap-2">
        <GripVertical className="w-4 h-4 opacity-50 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="font-medium text-sm truncate">{event.title}</div>
          {event.start_time && (
            <div className="text-xs opacity-75 flex items-center gap-1 mt-0.5">
              <Clock className="w-3 h-3" />
              {event.start_time}{event.end_time && ` - ${event.end_time}`}
            </div>
          )}
          {event.location && (
            <div className="text-xs opacity-75 flex items-center gap-1 mt-0.5">
              <MapPin className="w-3 h-3" />
              <span className="truncate">{event.location}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DraggableEvent;
